// Lightweight i18n for LimHappyShop
// Two languages only: Bahasa Indonesia (id), English (en)

const translations = {
  id: {
    // Common
    home: 'Beranda',
    cart: 'Keranjang',
    profile: 'Profil',
    admin: 'Admin',
    luckyDraw: 'Undian',
    inventory: 'Inventaris',
    topUp: 'Top Up',
    coinHistory: 'Riwayat Coin',
    drawHistory: 'Riwayat Undian',
    tickets: 'Tiket',
    accountSettings: 'Pengaturan Akun',
    logout: 'Keluar',
    cancel: 'Batal',
    save: 'Simpan',
    submit: 'Kirim',
    back: 'Kembali',
    loading: 'Memuat...',
    success: 'Berhasil',
    error: 'Terjadi kesalahan',

    // Profile
    myProfile: 'Profil Saya',
    coinBalance: 'Saldo Coin',
    ticketBalance: 'Tiket · Cashback 0.2%',
    orderHistory: 'Riwayat Pesanan',
    noOrders: 'Belum ada pesanan',
    changePassword: 'Ganti Password',
    currentPassword: 'Password saat ini',
    newPassword: 'Password baru (min 6 karakter)',
    confirmPassword: 'Konfirmasi password baru',
    updatePassword: 'Perbarui Password',

    // Account Settings
    accountSettingsTitle: 'Pengaturan Akun',
    securitySection: 'Keamanan',
    phoneSection: 'Verifikasi Nomor HP',
    languageSection: 'Bahasa',
    phoneNumber: 'Nomor HP',
    phoneNumberPlaceholder: '+628xxxxxxxxxx',
    sendOTP: 'Kirim Kode OTP',
    enterOTP: 'Masukkan 6 digit kode OTP',
    verifyOTP: 'Verifikasi',
    phoneVerified: 'Terverifikasi',
    phoneNotVerified: 'Belum Diverifikasi',
    selectLanguage: 'Pilih bahasa',
    indonesian: 'Bahasa Indonesia',
    english: 'English',
    languageSaved: 'Bahasa berhasil disimpan',

    // Top Up
    topUpTitle: 'Top Up Coins',
    selectPackage: 'Pilih Paket',
    customAmount: 'Jumlah Custom',
    paymentMethod: 'Metode Pembayaran',
    uploadProof: 'Upload Bukti Pembayaran',
    chooseImage: 'Pilih Gambar (maks 5MB)',
    orPasteUrl: 'ATAU paste URL gambar',
    submitTopUp: 'Submit Top Up',

    // Validation
    passwordMismatch: 'Konfirmasi password tidak cocok',
    passwordTooShort: 'Password minimal 6 karakter',
    fillAllFields: 'Mohon isi semua kolom',
  },
  en: {
    // Common
    home: 'Home',
    cart: 'Cart',
    profile: 'Profile',
    admin: 'Admin',
    luckyDraw: 'Lucky Draw',
    inventory: 'Inventory',
    topUp: 'Top Up',
    coinHistory: 'Coin History',
    drawHistory: 'Draw History',
    tickets: 'Tickets',
    accountSettings: 'Account Settings',
    logout: 'Logout',
    cancel: 'Cancel',
    save: 'Save',
    submit: 'Submit',
    back: 'Back',
    loading: 'Loading...',
    success: 'Success',
    error: 'Something went wrong',

    // Profile
    myProfile: 'My Profile',
    coinBalance: 'Coin Balance',
    ticketBalance: 'Tickets · 0.2% Cashback',
    orderHistory: 'Order History',
    noOrders: 'No orders yet',
    changePassword: 'Change Password',
    currentPassword: 'Current password',
    newPassword: 'New password (min 6 chars)',
    confirmPassword: 'Confirm new password',
    updatePassword: 'Update Password',

    // Account Settings
    accountSettingsTitle: 'Account Settings',
    securitySection: 'Security',
    phoneSection: 'Phone Verification',
    languageSection: 'Language',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: '+628xxxxxxxxxx',
    sendOTP: 'Send OTP',
    enterOTP: 'Enter 6-digit OTP code',
    verifyOTP: 'Verify',
    phoneVerified: 'Verified',
    phoneNotVerified: 'Not verified',
    selectLanguage: 'Select language',
    indonesian: 'Bahasa Indonesia',
    english: 'English',
    languageSaved: 'Language saved',

    // Top Up
    topUpTitle: 'Top Up Coins',
    selectPackage: 'Select Package',
    customAmount: 'Custom Amount',
    paymentMethod: 'Payment Method',
    uploadProof: 'Upload Payment Proof',
    chooseImage: 'Choose Image (max 5MB)',
    orPasteUrl: 'OR paste image URL',
    submitTopUp: 'Submit Top Up',

    // Validation
    passwordMismatch: 'Confirm password does not match',
    passwordTooShort: 'Password must be at least 6 characters',
    fillAllFields: 'Please fill all fields',
  },
};

export const getLanguage = () => {
  return localStorage.getItem('lh_language') || 'id';
};

export const setLanguage = (lang) => {
  if (lang === 'id' || lang === 'en') {
    localStorage.setItem('lh_language', lang);
    window.dispatchEvent(new Event('lh_language_change'));
  }
};

export const t = (key) => {
  const lang = getLanguage();
  return translations[lang]?.[key] || translations.id[key] || key;
};
